<div class="app-loading" [ngClass]="{ 'background-login': !isSecure }">
  <router-outlet></router-outlet>
  <sd-release-flags></sd-release-flags>
  <tanstack-query-debugger></tanstack-query-debugger>
</div>
